import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import VerifyEmail from './components/auth/VerifyEmail';
import UserForm from './components/lab/UserForm';
import Lab from './components/lab/Lab';
import Home from './components/lab/Home';
import Wallet from './components/wallet/Wallet';
import PrivateRoute from './PrivateRoute';
import PrivateUserRoute from './PrivateUserRoute';
import Computation from './components/lab/Computation'
import PredictionNew from './components/lab/PredictionNew';
import DetailsResultsAnal from './components/lab/DetailsResultsAnal';
import ChooseModel from './components/lab/ChooseModel';
import ModelsInfo from './components/lab/ModelsInfo';
import Summary from './components/lab/Summary';
import myIcon from './components/lab/images/favicon.ico';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Contact from './components/lab/Contact';
import RedeemCoupon from './components/lab/RedeemCoupon';


function App() {
    const [isCollapsed, setIsCollapsed] = useState(false);

    useEffect(() => {
        const link = document.querySelector("link[rel~='icon']");
        if (link) {
          link.href = myIcon;
        } else {
          const newLink = document.createElement("link");
          newLink.rel = "icon";
          newLink.href = myIcon;
          document.head.appendChild(newLink);
        }
      }, []);

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Navigate to="/home" replace />} />
                    <Route path="/login" element={<LoginForm />} />
                    <Route path="/register" element={<RegisterForm />} />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/user-form" element={<PrivateUserRoute element={UserForm} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route path="/home" element={<PrivateRoute element={Home} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route path="/models-info" element={<PrivateRoute element={ModelsInfo} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route path="/wallet" element={<PrivateRoute element={Wallet} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route path="/laboratory" element={<PrivateRoute element={Lab} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route path="/new-pred/:analysisPk?" element={<PrivateRoute element={PredictionNew} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route path="/laboratory/summary/:pk" element={<PrivateRoute element={Summary} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route path="/laboratory/computation/:pk" element={<PrivateRoute element={Computation} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route path="/laboratory/results/:pk" element={<PrivateRoute element={DetailsResultsAnal} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route 
                        path="/choose-model/:endpointPk/:analysisPk?" 
                        element={<PrivateRoute element={ChooseModel} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} 
                    />
                    <Route path="/contact" element={<PrivateRoute element={Contact} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
                    <Route path="/redeem-coupon" element={<PrivateRoute element={RedeemCoupon} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />

                </Routes>
            </div>
        </Router>
    );
}

export default App;
